/**
 * PubSuite add_to_cart tracking for the Online Store.
 */
(function () {
  'use strict';

  /** @type {number} */
  let lastAddToCartAt = 0;
  const ADD_TO_CART_DEBOUNCE_MS = 600;
  const DEBUG = /[?&]pubsuite_debug=1(?:&|$)/.test(window.location.search);

  /**
   * @param {string} name
   * @param {Record<string, string> | undefined} metadata
   */
  function trackConversion(name, metadata) {
    if (typeof window.pubSuiteTrack === 'function') {
      window.pubSuiteTrack(name, metadata);
      return;
    }

    if (window.pubSuite && typeof window.pubSuite.sendConversion === 'function') {
      try {
        if (metadata && Object.keys(metadata).length > 0) {
          window.pubSuite.sendConversion(name, JSON.stringify(metadata));
        } else {
          window.pubSuite.sendConversion(name);
        }
      } catch (error) {
        console.error('[PubSuite] conversion failed:', name, error);
      }
    }
  }

  /** @param {() => void} fn */
  function onPubSuiteReady(fn) {
    if (window.__pubSuiteReady) {
      fn();
      return;
    }
    document.addEventListener('pubsuite:ready', fn, { once: true });
  }

  function shouldDebounceAddToCart() {
    const now = Date.now();
    if (now - lastAddToCartAt < ADD_TO_CART_DEBOUNCE_MS) return true;
    lastAddToCartAt = now;
    return false;
  }

  /**
   * @param {Record<string, unknown> | undefined} data
   */
  function trackAddToCart(data) {
    if (shouldDebounceAddToCart()) return;

    /** @type {Record<string, string>} */
    const metadata = {};
    if (data?.variantId != null) metadata.content_id = String(data.variantId);
    else if (data?.productId != null) metadata.content_id = String(data.productId);
    if (data?.itemCount != null) metadata.item_quantity = String(data.itemCount);

    onPubSuiteReady(() => {
      trackConversion(
        'add_to_cart',
        Object.keys(metadata).length > 0 ? metadata : undefined
      );
      if (DEBUG) console.log('[PubSuite] add_to_cart tracked', metadata);
    });
  }

  /**
   * @param {CustomEvent} event
   */
  function handleCartUpdate(event) {
    if (event.detail?.data?.didError) return;
    trackAddToCart(event.detail?.data);
  }

  document.addEventListener('cart:update', handleCartUpdate);

  (function (ns, fetch) {
    ns.fetch = function () {
      const response = fetch.apply(this, arguments);
      const url = String(arguments[0]?.url || arguments[0] || '');

      if (!url.includes('/cart/add')) return response;

      response
        .then((res) => {
          if (!res.ok) return null;
          return res
            .clone()
            .json()
            .catch(() => null);
        })
        .then((data) => {
          if (!data || data.status) return;
          trackAddToCart({
            variantId: data.variant_id,
            productId: data.product_id,
            itemCount: data.quantity,
          });
        })
        .catch(() => {});

      return response;
    };
  })(window, window.fetch);
})();
